export const initialState = {
  graficoState: {
    isLoading: true,
    escalaDeRadio: 0.7
  },
  camara: { position: '45 50 90', rotacion: '-25 0 0', huds: [] },
  siloOperando: null
}
export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_SILOS_3D':
      return {
        ...state,
        graficoState: { ...state.graficoState, ...action.newState }
      }
    case 'SELECT_SILO':
      return {
        ...state,
        tableState: { ...state.tableState, searchText: action.id }
      }
    case 'SELECT_SECTOR':
      return {
        ...state,
        camara: { ...state.camara, position: `${action.sector.startingXPosition + action.sector.xLarge / 2} 50 90`, rotacion: '-25 0 0' }
      }
    case 'RESET_CAMERA':
      return {
        ...state,
        camara: {
          ...state.camara, position: `1 1 1`, rotacion: '1 1 1' }
      }
    case 'SET_HUDS':
      return {
        ...state,
        camara: { ...initialState.camara, huds: action.huds }
      }
    case 'UPDATE_SILO_OPERANDO':
      return {
        ...state,
        siloOperando: action.silo
      }
    default:
      return state
  }
}
